//This is the terms and conditions page

import TermsAndConditionsComponent from "../NonMVPComponents/TermsAndConditionsComponent";

const TermsAndConditions = () => {
  return (
    <div>
      <TermsAndConditionsComponent />
    </div>
  );
};

export default TermsAndConditions;
